import { DISCOVERY_LAB_DISTRICTS } from '../DiscoveryLabConfig.js';
import {
  EvidenceLabScene,
  type EvidenceLabRouteDefinition,
} from '../minigames/evidence-lab/EvidenceLabScene.js';
import {
  LIFE_CYCLE_ASSETS,
  LIFE_CYCLE_ASSET_LIST,
  canEnterLifeCyclePond,
  getMissingLifeCycleAssets,
} from './LifeCycleAssets.js';
import { LIFE_CYCLE_INVESTIGATION } from './LifeCycleConfig.js';
import { canEnterSoundVibrationDeck } from '../sound-vibration-deck/SoundVibrationAssets.js';

export const LIFE_CYCLE_SCENE_KEY = 'LifeCyclePond';

const ROUTE: EvidenceLabRouteDefinition = {
  sceneKey: LIFE_CYCLE_SCENE_KEY,
  sceneTitle: 'LIFE CYCLE POND',
  district: DISCOVERY_LAB_DISTRICTS.lifeCyclePond,
  previousScene: 'PlantGrowthHouse',
  previousLabel: 'PLANT GROWTH HOUSE',
  nextDistrict: DISCOVERY_LAB_DISTRICTS.soundVibrationDeck,
  nextScene: 'SoundVibrationDeck',
  nextLabel: 'SOUND & VIBRATION DECK',
  nextUnavailableMessage:
    'The listening deck is unlocked. Sound & Vibration Deck is awaiting its runtime QA gate.',
  config: LIFE_CYCLE_INVESTIGATION,
  assets: {
    dormant: LIFE_CYCLE_ASSETS.dormant,
    restored: LIFE_CYCLE_ASSETS.restored,
    card: LIFE_CYCLE_ASSETS.card,
  },
  assetList: LIFE_CYCLE_ASSET_LIST,
  getMissing: getMissingLifeCycleAssets,
  canEnter: canEnterLifeCyclePond,
  canEnterNext: canEnterSoundVibrationDeck,
};

export class LifeCycleScene extends EvidenceLabScene {
  static readonly requiredImageKeys = LIFE_CYCLE_ASSET_LIST.map(asset => asset.key);

  constructor() {
    super(ROUTE);
  }
}
